'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  cursor: ', ';\n  &:hover {\n    ', '\n  }\n'], ['\n  width: 100%;\n  cursor: ', ';\n  &:hover {\n    ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 0.1em 0.5em;\n  min-width: 50px;\n  width: auto;\n  text-align: center;\n  border-radius: 15px;\n  margin: 0 auto;\n'], ['\n  padding: 0.1em 0.5em;\n  min-width: 50px;\n  width: auto;\n  text-align: center;\n  border-radius: 15px;\n  margin: 0 auto;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding: 0.1em 0.5em;\n  min-width: 50px;\n  width: auto;\n  text-align: left;\n  border-radius: 15px;\n  margin: 0 auto;\n'], ['\n  padding: 0.1em 0.5em;\n  min-width: 50px;\n  width: auto;\n  text-align: left;\n  border-radius: 15px;\n  margin: 0 auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 15px;\n  line-height: 15px;\n  height: 15px;\n  margin-top: 2px;\n  color: ', ';\n  border-radius: 100%;\n'], ['\n  position: absolute;\n  width: 15px;\n  line-height: 15px;\n  height: 15px;\n  margin-top: 2px;\n  color: ', ';\n  border-radius: 100%;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 23px;\n  line-height: 23px;\n  height: 23px;\n  background: ', ';\n  color: ', ';\n  border-radius: 100%;\n'], ['\n  position: absolute;\n  width: 23px;\n  line-height: 23px;\n  height: 23px;\n  background: ', ';\n  color: ', ';\n  border-radius: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.hasOnClick ? 'pointer' : 'normal';
}, function (props) {
  return props.hasOnClick && '\n       border-radius: 15px;\n       box-shadow: ' + _color2.default.purple_accent + ' 0px 8px 10px 0px;\n    ';
});

var Pill = _styledComponents2.default.div(_templateObject2);

var NoBorderPill = _styledComponents2.default.div(_templateObject3);

var NoBorderIcon = _styledComponents2.default.div(_templateObject4, _color2.default.t3);

var Icon = _styledComponents2.default.div(_templateObject5, _color2.default.r34, _color2.default.white);

var getColor = function getColor(style, color_) {
  var styleColor = Object.assign({}, style);
  var background = _color2.default.grey_accent_1;
  var textcolor = _color2.default.blue_main;
  if (color_) {
    switch (color_) {
      case 'pink':
        background = _color2.default.t5;
        textcolor = _color2.default.t2;
        break;
      case 'blue':
        background = _color2.default.t8;
        textcolor = _color2.default.t9;
        break;
      case 'green':
        background = _color2.default.t6;
        textcolor = _color2.default.t7;
        break;
      case 'grey':
        background = _color2.default.t3;
        textcolor = _color2.default.t4;
        break;
      case 'yellow':
        background = _color2.default.t1;
        textcolor = _color2.default.t2;
        break;
      case 'white':
        background = _color2.default.blue_main;
        textcolor = _color2.default.white;
        break;
      case 'darkred':
        background = _color2.default.r34;
        textcolor = _color2.default.white;
        break;
      case 'darkgreen':
        background = _color2.default.t7;
        textcolor = _color2.default.white;
        break;
      default:
        background = _color2.default[color_];
        textcolor = _color2.default.blue_main;
        break;
    }
  }
  styleColor.background = background;
  styleColor.color = textcolor;
  return styleColor;
};

var MozartPillBadge = function MozartPillBadge(props) {
  var border = props.border,
      style = props.style,
      data = props.data,
      icon = props.icon,
      color = props.color,
      _onClick = props.onClick,
      iconStyle = props.iconStyle;

  var style_ = getColor(style, color);
  var iconStyle_ = iconStyle && iconStyle.backgroundColor ? getColor(iconStyle, iconStyle.backgroundColor) : {};
  iconStyle_.color = color.white;
  if (!border) {
    style_.background = color.white;
    return _react2.default.createElement(
      Container,
      { onClick: function onClick() {
          if (_onClick) {
            _onClick();
          }
        } },
      _react2.default.createElement(NoBorderIcon, { style: iconStyle_ }),
      _react2.default.createElement(
        NoBorderPill,
        { style: Object.assign({ paddingLeft: '20px' }, style_) },
        data
      )
    );
  }

  return _react2.default.createElement(
    Container,
    { 'data-qa': props.testId, 'data-theme': props.themeId, onClick: function onClick() {
        if (_onClick) {
          _onClick();
        }
      }, hasOnClick: _onClick ? true : false },
    icon && _react2.default.createElement(
      Icon,
      { style: iconStyle_ },
      icon
    ),
    _react2.default.createElement(
      Pill,
      { style: icon ? Object.assign({ paddingLeft: '29px' }, style_) : style_ },
      data
    )
  );
};

MozartPillBadge.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** iconStyle */
  iconStyle: _propTypes2.default.object,
  /** no border with indicator on the left */
  border: _propTypes2.default.bool,
  /** color scheme: pink, blue, green, grey, yellow */
  color: _propTypes2.default.string,
  /** icon */
  icon: _propTypes2.default.string,
  /** content */
  data: _propTypes2.default.oneOf([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]).isRequired,
  /** on click callback */
  onClick: _propTypes2.default.func
};

MozartPillBadge.defaultProps = {
  style: {},
  color: 'grey',
  data: '',
  border: true,
  testId: 'MozartPillBadge',
  themeId: 'MozartPillBadge'
};

exports.default = MozartPillBadge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartBadge/MozartPillBadge/MozartPillBadge.js
// module id = 1830
// module chunks = 1